import {attemptMemberIds, type StudentAttempt} from "./activity-library";
import type {SchoolClass} from "./ClassesView";

export function correctionOwnerSortLabel(attempt: StudentAttempt, classes: SchoolClass[]) {
  if (attempt.ownerType === "group" && attempt.groupName?.trim()) return attempt.groupName.trim();
  const schoolClass = classes.find(c => c.id === attempt.classId);
  return attemptMemberIds(attempt).map(id => {
    const student = schoolClass?.students.find(s => s.id === id);
    return student ? `${student.lastName} ${student.firstName}` : id;
  }).join(" · ");
}

export function sortCorrectionCopies(copies: StudentAttempt[], classes: SchoolClass[]) {
  return [...copies].sort((a,b) =>
    correctionOwnerSortLabel(a,classes).localeCompare(correctionOwnerSortLabel(b,classes),"fr",{sensitivity:"base",numeric:true}) ||
    a.id.localeCompare(b.id)
  );
}
